export default "__VITE_ASSET__BsbUiW0___"